import { Tooltip } from 'antd';
import { useState, useEffect, useRef } from 'react';

const BackTopButton = () => {
    const [showButton, setShowButton] = useState(false);
    const lastPosition = useRef(0);

    const scrollToTop = () => {
        const container = document.getElementById('content-container');
        container?.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        const container = document.getElementById('content-container');
        const checkScrollHeight = () => {
            if (!container)
                return;
            if (!showButton && container.scrollTop > 100 && container.scrollTop < lastPosition.current)
                setShowButton(true);
            else if (showButton && (container.scrollTop < 100 || container.scrollTop > lastPosition.current))
                setShowButton(false);
            lastPosition.current = container.scrollTop;
        };
        container?.addEventListener('scroll', checkScrollHeight);
        return () => {
            container?.removeEventListener('scroll', checkScrollHeight);
        };
    }, [showButton]);

    return (
        <Tooltip title="برگشتن به بالای صفحه" placement="rightTop">
            <span className="backTopButtonContainer" style={{ display: showButton ? 'flex' : 'none' }} onClick={scrollToTop}>
                <svg
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#ffffff"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M12 19V5M5 12l7-7 7 7" />
                </svg>
            </span>
        </Tooltip>
    );
};

export default BackTopButton;